import { render, staticRenderFns } from "./viewDiagnosis.vue?vue&type=template&id=21a81fcc&scoped=true&"
import script from "./viewDiagnosis.vue?vue&type=script&lang=js&"
export * from "./viewDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./viewDiagnosis.vue?vue&type=style&index=0&id=21a81fcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a81fcc",
  null
  
)

export default component.exports